module.exports = __webpack_public_path__ + "bf2e0ff2999ef3d5d562dcf1e397d21d.png";